import { AddCardLineCombinedProps } from './types';

const usePresenter = (props: AddCardLineCombinedProps): AddCardLineCombinedProps => {
  return props;
};

export default usePresenter;
